import { Bee } from '@serodigital/ies-api-client';
import * as React from 'react';
import { IControlPeripheral } from '../state/types';
import { DataProcessing } from './dataProcessing';
import { HeatPumpControl } from './heatPumpControl';

interface IProps {
  peripherals: IControlPeripheral[];
  bee: Bee;
  allowedToEditTags: boolean;
}

export function SettingsView({ peripherals, bee, allowedToEditTags }: IProps) {
  return (
    <div className="w-full h-full mt-8" data-qa="settings-details">
      {peripherals.map((peripheral) => (
        <div key={peripheral.deviceType} className="pb-24">
          <HeatPumpControl control={peripheral} />
        </div>
      ))}
      <DataProcessing bee={bee} allowedToEditTags={allowedToEditTags} />
    </div>
  );
}
